import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  titleAddressForm: {
    // shipping adress text
    fontSize: "1em",
    fontFamily: "Syncopate-Bold",
    color: "#f1b211",
    textTransform: "capitalize",
    fontWeight: "100",
    opacity: "0.6",
    marginBottom: "20px",
  },
  //
  addressFormStyle: {
    fontSize: "1.5em",
    fontFamily: "Syncopate-Regular",
    textTransform: "capitalize",
    fontWeight: "100",
  },

  //--------------------

  //*** Its not possible to change the color of the font inside all the fields related to name,lastName etc, i think its because its sensitive data and the component is coming from material ui, as when you read line 16 from AddressForm.jsx, and you go to the component, you will understand that its not possible to add style={{}} to anything inside the GRid***
  //
  // fontStylesForm: {
  //   fontFamily: "Syncopate-Bold",
  //   color: "red",
  //   textTransform: "capitalize",
  //   fontSize: "1.5em",
  //   fontWeight: "100",
  // },
  // -------------------
  //
  buttonBackToCart: {
    marginTop: "30px",
    padding: "0.7em 1.5em",
    fontSize: `calc(4px + 1.1vmin)`,

    //
    border: "2px solid #fbfbfb",
    boxShadow: "10px 11px 0px 1px  rgba(0,0,0,0.88)",
    borderRadius: "8em",
    boxSizing: "borderBox",
    textDecoration: "none",
    fontWeight: "600",
    //
    backgroundColor: "#121212",
    color: "rgb(248,248,248)",
    textAlign: "center",
    transition: "all 0.3s ease-in-out",
    // responsive button and space between this and the other button
    minWidth: "150px",

    //
    //
    //  *** MEDIA querie
    //
    [theme.breakpoints.down("xs")]: {
      marginBottom: "20px",
      padding: "1em 3em",
      fontSize: `calc(7px + 1.1vmin)`,
      minWidth: "80px",
    },
    [theme.breakpoints.up("sm")]: {
      marginRight: "20px",
    },

    //
    // *** Hover Btn
    //
    "&:hover": {
      padding: "0.7em 3em",

      //
      borderRadius: "1em",
      border: "2px solid #121212",
      boxShadow: "10px 11px 0px 1px  rgba(0,0,0,0.88)",
      //"#f3ff71",
      //"#ff0080", //magenta

      backgroundColor: "#fbfbfb",
      color: "#121212",
      //
      [theme.breakpoints.down("xs")]: {
        marginBottom: "5px",
      },
      [theme.breakpoints.up("sm")]: {
        marginRight: "20px",
      },
    },
  },

  //
  buttonAddressForm: {
    marginTop: "30px",
    padding: "0.7em 1.5em",
    fontSize: `calc(4px + 1.1vmin)`,

    //

    color: "#121212",
    backgroundColor: "#00ffb3",
    border: "2px solid #121212",
    boxShadow: "10px 11px 0px 1px  rgba(0,0,0,0.88)",
    borderRadius: "8em",

    boxSizing: "borderBox",
    textDecoration: "none",
    fontWeight: "600",
    //

    textAlign: "center",
    transition: "all 0.3s ease-in-out",
    // responsive button and space between this and the other button
    minWidth: "150px",

    //
    //  *** MEDIA querie
    //
    [theme.breakpoints.down("xs")]: {
      marginTop: "5px",
      padding: "1em 5em",
      fontSize: `calc(7px + 1.1vmin)`,
      minWidth: "80px",
    },
    [theme.breakpoints.up("sm")]: {},

    //
    //
    "&:hover": {
      padding: "0.7em 4em",
      //
      borderRadius: "1em",
      border: "2px solid #121212",
      boxShadow: "10px 11px 0px 1px  rgba(0,0,0,0.88)",
      backgroundColor: "#f3ff71",
      color: "#121212",
    },
  },
}));
